import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'booking_cancellation_error';
export const route = 'booking_cancellation/error/[[...primeFreeCancellationParams]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../../components/ErrorPage')));